<template>
    <div style="height:100%;background:rgba(250, 250, 250, 1);overflow: hidden;padding: 70px 0 0px;position: relative;width: 100%;">
        <div v-if="currentStep>2" style="position: absolute;width: 100%;height: 50px;text-align: center;background:#fff;left:0px;top:0px;border-bottom: 1px solid rgba(229, 229, 229, 1);">
            <div style="width:100%;height:100%;position:relative;">
                <span style="color:rgba(18, 18, 18, 1);font-size:16px;font-weight:bold;line-height: 50px;line-height:50px">{{biographicalDetail.name}}</span>
                <div style="position:absolute;right:32px;display:inline-block;top:0px;">
                    <span style="color:rgba(18, 18, 18, 1);font-size:13px;margin-top:17px;float:left;">分享：</span>
                    <a-switch @change="changeShare" v-model="shareSwitch" style="margin:15px 8px 0 4px;float:left;" />
                    <span v-if="biographicalDetail.isShare==1" style="color:rgba(158, 172, 196, 1);font-size:12px;margin-top:18px;float:left">已开启</span>
                    <span v-if="biographicalDetail.isShare==0" style="color:rgba(158, 172, 196, 1);font-size:12px;margin-top:18px;float:left">已关闭</span>
                    <span style="color:rgba(18, 18, 18, 1);font-size:13px;margin-top:17px;float:left;margin-left:32px">会话：</span>
                    <a-switch @change="changeChat" v-model="chatSwitch" style="margin:15px 8px 0 4px;float:left;" />
                    <span v-if="biographicalDetail.isOpenChat==1" style="color:rgba(158, 172, 196, 1);font-size:12px;margin-top:18px;float:left">已开启</span>
                    <span v-if="biographicalDetail.isOpenChat==0" style="color:rgba(158, 172, 196, 1);font-size:12px;margin-top:18px;float:left">已关闭</span>
                    <span @click="shareModal" style="display:inline-block;width:80px;height:32px;line-height:30px;border:1px solid rgba(34, 215, 187, 1);background:rgba(34, 215, 187, 0.08);border-radius:4px;color:rgba(34, 215, 187, 1);font-size:14px;cursor:pointer;margin-left:44px;margin-top:10px;">分享</span>
                </div>
            </div>
        </div>
        <div class="step-progress" v-if="!readOnly&&jumpSource!='view'">
            <a-steps :current="currentStep" size="default">
                <a-step title="选择职业背景" />
                <a-step title="对话构建业务背景" />
                <a-step title="完善简历" />
                <a-step title="开启chatgpt功能" />
            </a-steps>
        </div>
        <div class="last-step" v-if="!readOnly&&jumpSource!='view'">
            <span @click="lastStep">
                <a-icon type="arrow-left" />
            </span>
            <div>上一步</div>
        </div>
        <div class="next-step" v-if="!readOnly&&currentStep!=4&&jumpSource!='view'">
            <span @click="nextStep">
                <a-icon type="arrow-right" />
            </span>
            <div>下一步</div>
        </div>
        <div v-if="currentStep==0" style="height:100%;padding-bottom:120px;">
            <div style="width: 1200px;background: #fff;border-radius: 20px;border: 1px solid rgba(229, 231, 235, 1);overflow: hidden;display: flex;height: 100%;margin: 0 auto;">
                <div style="width: 360px;background:rgba(34, 215, 187, 0.08);border-right: 1px solid rgba(229, 231, 235, 1);height: 100%;padding: 128px 32px 0 32px;">
                    <div style="color:rgba(18, 18, 18, 1);font-size: 20px;font-weight:bold;">step1</div>
                    <div style="color:rgba(18, 18, 18, 1);font-size: 24px;font-weight:bold;margin-top:148px;">{{step1Detail.name}}</div>
                    <div style="color:rgba(80, 80, 80, 1);font-size:13px;margin-top:16px">{{step1Detail.des}}</div>
                </div>
                <div style="flex: 1;">
                    <div>
                        <a-icon type="close" style="float: right;color: rgba(158, 172, 196, 1);font-size:18px;margin:16px 16px 0 0;cursor: pointer;" />
                    </div>
                    <div class="chart-box" style="height: 570px;overflow-y: auto;margin-top:72px;padding: 0 32px 0 11px;">
                        <div class="chart-item" :class="{'chart-item-active':tplId==item.id}" v-for="(item,index) in jobTplList" :key="index" @click="chooseTpl(item)">
                            <div class="chart-body">
                                <div class="left-chart">
                                    <div class="img-box">
                                        <img class="img-avatar" :src="item.avatar" alt="">
                                    </div>
                                    <div style="color:rgba(255, 87, 51, 1)">
                                        <img style="width:14px;float:left;margin-top:4px;margin-left:14px;" src="../assets/img/fire.svg" alt="">
                                        <span style="margin-left:2px;font-size:12px;float:left;margin-top:2px;">{{ item.heat }}</span>
                                    </div>
                                </div>
                                <div class="right-chart">
                                    <div class="chart-name">{{item.name}}</div>
                                    <div class="chart-content">{{item.description}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style="text-align: right;margin-top: 20px;padding-right: 32px;">
                        <div style="display:inline-block;width: 245px;height: 80px;border: 1px solid rgba(229, 231, 235, 1);border-radius: 16px;text-align: center;line-height: 80px;cursor: pointer;">
                            <span style="color:rgba(158, 172, 196, 1);font-size:16px;">没有想要的职业</span>
                            <span style="display: inline-block;width: 48px;height: 48px;border-radius: 11px;border:1px solid rgba(229, 231, 235, 1);text-align: center;color: rgba(34, 215, 187, 1);font-size: 20px;line-height: 48px;float: right;margin: 16px 32px 0 0;">
                                <a-icon type="question" />
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="currentStep==1" style="height:100%;padding-bottom:120px;">
            <div style="width: 1200px;background: #fff;border-radius: 20px;border: 1px solid rgba(229, 231, 235, 1);overflow: hidden;display: flex;height: 100%;margin: 0 auto;">
                <div style="flex:1;background: rgba(34, 215, 187, 0.08);border-right: 1px solid rgba(229, 231, 235, 1);padding: 128px 38px 0 32px;">
                    <div style="color:rgba(18, 18, 18, 1);font-size:20px;font-weight:bold">step2</div>
                    <div style="margin-top: 60px;">
                        <img style="width:64px;border-radius: 32px;border: 1px solid rgba(34, 215, 187, 1);" src="../assets/img/step-avator.png" alt="">
                    </div>
                    <div style="color: rgba(18, 18, 18, 1);font-size:24px;font-weight:bold;margin-top:24px;">对话构建【{{step1Detail.name}}】业务背景</div>
                    <div style="color:rgba(80, 80, 80, 1);font-size:13px;margin-top:16px">语言模型会向您提出关于所选职业背景的问题，以便了解其业务背景和特点。这些问题可能涉及到该职业的常见问题、相关技术和工具、行业趋势等方面。您可以根据自己的经验和知识来回答这些问题，帮助语言模型更好地理解所创建的职业人设。</div>
                </div>
                <div style="width: 360px;text-align: center;line-height: 700px;">
                    <img style="width: 160px;" src="../assets/img/step-2.png" alt="">
                </div>
            </div>
        </div>
        <div v-if="currentStep==2" style="height:100%;padding-bottom:120px;">
            <div style="width: 1200px;background: #fff;border-radius: 20px;border: 1px solid rgba(229, 231, 235, 1);overflow: hidden;display: flex;height: 100%;margin: 0 auto;">
                <div style="width: 360px;background:rgba(34, 215, 187, 0.08);border-right: 1px solid rgba(229, 231, 235, 1);height: 100%;padding: 128px 32px 0 32px;">
                    <div style="color:rgba(18, 18, 18, 1);font-size: 20px;font-weight:bold;">step2</div>
                    <div style="color:rgba(18, 18, 18, 1);font-size: 24px;font-weight:bold;margin-top:148px;">与角色对话</div>
                    <div style="color:rgba(80, 80, 80, 1);font-size:13px;margin-top:16px">当前你的对话内容会作为构建语言助手认知的依据，请尽量准确的给与答复</div>
                </div>
                <div style="flex: 1;display: flex;flex-direction: column;">
                    <div style="height: 80px;border-bottom:1px solid rgba(229, 231, 235, 1);padding: 12px 12px 0 16px;">
                        <div>
                            <span style="color:rgba(18, 18, 18, 1);font-size:18px;font-weight:bold">{{step1Detail.name}}</span>
                            <a-icon style="float: right;color:rgba(158, 172, 196, 1);font-size:18px;cursor: pointer;;" type="close" />
                        </div>
                        <div style="color:rgba(158, 172, 196, 1);font-size:13px;margin-top:6px">已对话{{2*chatList.length-1}}条</div>
                    </div>
                    <div style="flex: 1;overflow-y: auto;padding: 24px 16px;" id="chatDiv">
                        <div v-for="(item,index) in chatList" :key="index">
                            <div class="gpt-role">
                                <span class="gpt-head">gpt</span>
                                <span v-if="item.question!=''" class="gpt-content">{{ item.question }}</span>
                                <a-icon v-if="!item.ifPlay&&item.question!=''" @click="tryListen(item.question,index,'tpl')" class="gpt-img" type="play-circle" />
                                <a-icon v-if="item.ifPlay" class="gpt-img" type="pause-circle" />
                                <span v-if="item.question==''" class="gpt-loading">
                                    <a-icon class="gpt-icon" type="loading" />正在输入中...
                                </span>
                            </div>
                            <div class="clean"></div>
                            <div class="user-role" v-if="item.answer!=''">
                                <span class="user-content">{{ item.answer }}</span>
                            </div>
                            <div class="clean"></div>
                        </div>
                        <div v-if="tryTplBool" class="gpt-error" style="margin-top:12px;">
                            <span @click="sendDataToTpl" style="color:rgba(42, 130, 228, 1);cursor:pointer;margin-left:40px;font-size:12px;text-decoration:underline">太慢啦，快些输入吧</span>
                        </div>
                    </div>
                    <div style="padding:0 16px 16px;position: relative;">
                        <a-textarea :disabled="disabledTpl" @keyup.enter="chatToTpl(1)" v-model="tplContent" style="border: 1px solid rgba(229, 231, 235, 1);border-radius: 8px;height:120px;display: inline-block;resize: none;" placeholder="请输入回答" ref="ainput">

                        </a-textarea>
                        <span @click="chatToTpl(1)" style="display: inline-block;width: 52px;height: 32px;text-align: center;line-height: 32px;background:rgba(34, 215, 187, 1);font-size: 14px;color:#fff;position: absolute;right: 24px;bottom:24px;cursor: pointer;border-radius: 6px;">发送</span>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="currentStep==3" style="height:100%;overflow-y:auto;padding-bottom:60px;">
            <div style="width: 1200px;margin: 0 auto;">
                <div style="padding:16px 24px;border: 1px solid rgba(229, 231, 235, 1);border-radius: 8px;background: #fff;">
                    <div style="color:rgba(18, 18, 18, 1);font-size: 18px;font-weight:bold;">基本信息</div>
                    <div style="display: flex;margin-top: 23px;box-shadow: rgba(158, 172, 196, 0.16) solid 3px;text-align: center;">
                        <div style="width: 64px;background: rgba(222, 213, 254, 1);border: 1px solid rgba(158, 172, 196, 0.16);height: 93px;">
                            <img style="width: 56px;margin-top:12px" :src="biographicalDetail.avatar" alt="">
                        </div>
                        <div style="flex:1">
                            <a-row class="basic-info">
                                <a-col :span="12" v-for="(item,index) in biographicalDetail.baseInfo" :key="index" style="padding-left:40px;">
                                    <div class="info-list">
                                        <span class="info-title">{{item.question}}：</span>
                                        <span v-if="!item.ifEdit" class="info-content">{{item.answer}}</span>
                                        <a-icon v-if="!item.ifEdit&&!readOnly" type="edit" @click="editInfoContent(index)" class="info-edit" />
                                        <a-icon v-if="!item.ifEdit&&!readOnly" type="close-circle" class="info-del" @click="delInfoList(index,item.qaId)" />
                                        <a-input v-if="item.ifEdit" placeholder="请输入信息" class="info-input" v-model='item.answer' />
                                        <span v-if="item.ifEdit" class="info-off" @click="offInfoContent(index)">取消</span>
                                        <span v-if="item.ifEdit" class="info-sure" @click="sureInfoContent(index, 1, item.qaId, item.question, item.answer)">保存</span>
                                    </div>
                                </a-col>
                            </a-row>
                            <div style="margin-top: 24px;text-align: center;" v-if="!readOnly">
                                <span style="height: 28px;line-height: 26px;background: rgba(34, 215, 187, 0.08);color:rgba(34, 215, 187, 1);border: 1px solid rgba(34, 215, 187, 1);font-size: 13px;cursor: pointer;width: 72px;height: 28px;display: inline-block;border-radius: 4px;" @click="addInfoList">
                                    <span style="margin-right:5px;font-size: 16px;">+</span>
                                    <span>新增</span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div style="padding:16px 12px 16px 24px;border: 1px solid rgba(229, 231, 235, 1);border-radius: 8px;background: #fff;margin-top: 16px;" class="job-duty">
                    <div style="color:rgba(18, 18, 18, 1);font-size: 18px;font-weight:bold;">工作职责</div>
                    <div style="display: flex;margin-top: 17px;" class="job-content">
                        <div style="flex: 1;">
                            <a-textarea v-model="biographicalDetail.responsibility.answer" v-if="biographicalDetail.responsibility.ifEdit" placeholder=""  :maxLength="200" />
                            <div v-if="!biographicalDetail.responsibility.ifEdit">{{ biographicalDetail.responsibility.answer }}</div>
                        </div>
                        <div style="display: inline-block;margin-left: 12px;line-height: 50px;width: 64px;">
                            <a-icon v-if="!biographicalDetail.responsibility.ifEdit&&!readOnly&&biographicalDetail.responsibility.answer!=''" type="edit" @click="editJobDuty()" class="job-edit" />
                            <span v-if="biographicalDetail.responsibility.ifEdit" style="cursor: pointer;color: rgba(158, 172, 196, 0.8);font-size: 13px;margin-right: 12px;" @click="offJobDuty">取消</span>
                            <span v-if="biographicalDetail.responsibility.ifEdit" style="cursor: pointer;color: rgba(34, 215, 187, 1);font-size: 13px;" @click="sureJobDuty(2, biographicalDetail.responsibility.qaId, '', biographicalDetail.responsibility.answer)">保存</span>
                        </div>
                    </div>
                    <div style="margin-top: 24px;text-align: center;" v-if="!readOnly&&biographicalDetail.responsibility.answer==''&&!biographicalDetail.responsibility.ifEdit">
                        <span style="height: 28px;line-height: 26px;background: rgba(34, 215, 187, 0.08);color:rgba(34, 215, 187, 1);border: 1px solid rgba(34, 215, 187, 1);font-size: 13px;cursor: pointer;width: 72px;height: 28px;display: inline-block;border-radius: 4px;" @click="editJobDuty()">
                            <span style="margin-right:5px;font-size: 16px;">+</span>
                            <span>新增</span>
                        </span>
                    </div>
                </div>
                <div style="padding:16px 12px 16px 24px;border: 1px solid rgba(229, 231, 235, 1);border-radius: 8px;background: #fff;margin-top: 16px;" class="bg-info">
                    <div style="color:rgba(18, 18, 18, 1);font-size: 18px;font-weight:bold;margin-bottom: 16px;">背景信息</div>
                    <div v-for="(item,index) in biographicalDetail.background" :key="index">
                        <div class="bg-list" style="display: flex;min-height: 77px;margin-bottom: 7px;" v-if="item.answer!=''">
                            <div style="background: rgba(244, 244, 245, 0.5);border-radius: 8px;padding: 5px 8px 0 12px;flex: 1;">
                                <div style="min-height:32px;display:flex;">
                                    <span style="display: inline-block;width:20px;height: 20px;border-radius: 5px;background: rgba(34, 215, 187, 1);margin-right:8px;text-align:center;line-height:20px;margin-top:7px">
                                        <a-icon style="color:#fff;font-size:12px;" type="search" />
                                    </span>
                                    <!-- <a-input v-model="item.question" v-if="item.ifEdit" placeholder="" style="flex:1" /> -->
                                    <a-textarea v-model="item.question" v-if="item.ifEdit" placeholder="" style="flex:1" auto-size />
                                    <span v-if="!item.ifEdit" style="color:rgba(0, 0, 0, 1);font-size:13px;margin-top:7px;flex:1">{{ item.question }}</span>
                                </div>
                                <div style="min-height:32px;display:flex;margin-top:2px">
                                    <span style="display: inline-block;width:20px;height: 20px;border-radius: 5px;background: rgba(42, 130, 228, 1);margin-right:8px;text-align:center;line-height:20px;margin-top:7px;color:#fff">
                                        A
                                    </span>
                                    <!-- <a-input v-model="item.answer" v-if="item.ifEdit" placeholder="" style="flex:1" /> -->
                                    <a-textarea v-model="item.answer" v-if="item.ifEdit" placeholder="" style="flex:1" auto-size />
                                    <span v-if="!item.ifEdit" style="color:rgba(0, 0, 0, 1);font-size:13px;margin-top:7px;flex:1">{{ item.answer }}</span>
                                </div>
                            </div>
                            <div style="display: inline-block;width: 64px;margin-left: 12px;line-height: 77px;">
                                <a-icon v-if="!item.ifEdit&&!readOnly" type="edit" @click="editBg(index)" class="edit-bg" />
                                <a-icon v-if="!item.ifEdit&&!readOnly" type="close-circle" @click="delBg(index,item.qaId)" class="del-bg" />
                                <span v-if="item.ifEdit" @click="offBg(index)" class="off-bg">取消</span>
                                <span v-if="item.ifEdit" @click="sureBg(index, 3, item.qaId, item.question, item.answer )" class="save-bg">保存</span>
                            </div>
                        </div>
                    </div>
                    <div style="margin-top: 17px;text-align: center;" v-if="!readOnly">
                        <span style="height: 28px;line-height: 26px;background: rgba(34, 215, 187, 0.08);color:rgba(34, 215, 187, 1);border: 1px solid rgba(34, 215, 187, 1);font-size: 13px;cursor: pointer;width: 72px;height: 28px;display: inline-block;border-radius: 4px;" @click="addBgInfo">
                            <span style="margin-right:5px;font-size: 16px;">+</span>
                            <span>新增</span>
                        </span>
                    </div>
                </div>
                <div style="padding:16px 12px 16px 24px;border: 1px solid rgba(229, 231, 235, 1);border-radius: 8px;background: #fff;margin-top: 16px;" class="extra-require">
                    <div style="color:rgba(18, 18, 18, 1);font-size: 18px;font-weight:bold;margin-bottom: 16px;">补充要求</div>
                    <div class="extra-list" style="display: flex;min-height: 34px;margin-bottom: 7px;line-height:34px;" v-for="(item,index) in biographicalDetail.supplement" :key="index">
                        <img style="width:16px;margin-right:8px;margin-top:3px" src="../assets/img/extra-icon.svg" alt="">
                        <div style="background: rgba(244, 244, 245, 0.5);border-radius: 8px;padding: 1px 2px;flex: 1;">
                            <!-- <a-input v-model="item.answer" v-if="item.ifEdit" placeholder=""/> -->
                            <a-textarea v-model="item.answer" v-if="item.ifEdit" placeholder="" auto-size />
                            <span v-if="!item.ifEdit" style="color:rgba(0, 0, 0, 1);font-size:13px;margin-top:7px">{{ item.answer }}</span>
                        </div>
                        <div style="display: inline-block;width: 64px;margin-left: 12px;line-height: 35px;">
                            <a-icon v-if="!item.ifEdit&&!readOnly" type="edit" @click="editExtra(index)" class="edit-extra" />
                            <a-icon v-if="!item.ifEdit&&!readOnly" type="close-circle" @click="delExtra(index,item.qaId)" class="del-extra" />
                            <span v-if="item.ifEdit" @click="offExtra(index)" class="off-extra">取消</span>
                            <span v-if="item.ifEdit" @click="sureExtra(index, 4, item.qaId, '', item.answer)" class="save-extra">保存</span>
                        </div>
                    </div>
                    <div style="margin-top: 17px;text-align: center;" v-if="!readOnly">
                        <span style="height: 28px;line-height: 26px;background: rgba(34, 215, 187, 0.08);color:rgba(34, 215, 187, 1);border: 1px solid rgba(34, 215, 187, 1);font-size: 13px;cursor: pointer;width: 72px;height: 28px;display: inline-block;border-radius: 4px;" @click="addExtraInfo">
                            <span style="margin-right:5px;font-size: 16px;">+</span>
                            <span>新增</span>
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="currentStep==4" style="height:100%;padding-bottom:120px;">
            <div style="width: 1200px;background: #fff;border-radius: 20px;border: 1px solid rgba(229, 231, 235, 1);overflow: hidden;display: flex;height: 100%;margin: 0 auto;">
                <div style="width: 360px;background:rgba(34, 215, 187, 0.08);border-right: 1px solid rgba(229, 231, 235, 1);height: 100%;padding: 128px 32px 0 32px;">
                    <div style="color:rgba(18, 18, 18, 1);font-size: 20px;font-weight:bold;">step4</div>
                    <div style="color:rgba(18, 18, 18, 1);font-size: 24px;font-weight:bold;margin-top:148px;">开启chatgpt功能</div>
                    <div style="color:rgba(80, 80, 80, 1);font-size:13px;margin-top:16px">在您完成GPT助手的职业人设设定后，可以通过相应场景来激活该助手。</div>
                </div>
                <div style="flex: 1;padding:0 32px;position:relative;">
                    <div>
                        <a-icon type="close" style="float: right;color: rgba(158, 172, 196, 1);font-size:18px;margin:16px -20px 0 0;cursor: pointer;" />
                    </div>
                    <img class="chart-box" style="width:100%;margin-top:160px;border-radius:8px;" src="./../assets/img/gpt-show.gif" alt="">
                    <span style="display:inline-block;width:78px;height:36px;text-align:center;line-height:36px;border-radius:6px;color:#fff;font-size:14px;background:rgba(34, 215, 187, 1);cursor: pointer;position:absolute;right:32px;bottom:24px;" @click="closeWindow">完成</span>
                </div>
            </div>
        </div>
        <a-modal :centered='true' :maskClosable='false' v-model.trim="deleteModal" footer='' width='480px' title="删除数据">
            <div>
                <div>
                    <a-icon type="warning" style="color:rgba(255, 170, 0, 1);font-size:20px;" />
                    <span style="color:rgba(80, 80, 80, 1);font-size:18px;margin-left:16px">删除后，数据无法恢复</span>
                </div>
                <div style="text-align:right;margin-top:32px">
                    <a-button ghost @click="cancelDelete">取消</a-button>
                    <a-button type="primary" @click="sureDelete" style="margin-left:16px;">确认</a-button>
                </div>
            </div>
        </a-modal>
        <a-modal :centered='true' :maskClosable='false' v-model.trim="failModal" footer='' width='480px' title="操作失败">
            <div>
                <div>
                    <a-icon type="warning" style="color:rgba(255, 170, 0, 1);font-size:20px;" />
                    <span style="color:rgba(80, 80, 80, 1);font-size:18px;margin-left:16px">对话模式下无法操作</span>
                </div>
                <div style="text-align:right;margin-top:32px">
                    <a-button ghost @click="cancelFail">取消</a-button>
                    <a-button type="primary" @click="sureFail" style="margin-left:16px;">确认</a-button>
                </div>
            </div>
        </a-modal>
        <a-modal :centered='true' :maskClosable='false' v-model.trim="delDataModal" footer='' width='480px' title="删除数据">
            <div>
                <div>
                    <a-icon type="warning" style="color:rgba(255, 170, 0, 1);font-size:20px;" />
                    <span style="color:rgba(80, 80, 80, 1);font-size:18px;margin-left:16px">关闭弹窗会清除对话记录？</span>
                </div>
                <div style="text-align:right;margin-top:32px">
                    <a-button ghost @click="cancelDelData">取消</a-button>
                    <a-button type="primary" @click="sureDelData" style="margin-left:16px;">确认</a-button>
                </div>
            </div>
        </a-modal>
        <a-modal :centered='true' :maskClosable='false' v-model.trim="basicInfoModal" footer='' width='480px' title="基本信息新增">
            <div>
                <div style="color:rgba(80, 80, 80, 1);font-size:14px">
                    请选择新增的字段：
                </div>
                <a-select placeholder="请选择字段" v-model="currentSelectWord" style="width: 100%;margin-top:12px;" @change="handleChange">
                    <a-select-option :value="item" v-for="(item,index) in basicInfoWordList" :key="index">
                        {{item}}
                    </a-select-option>
                </a-select>
                <div style="text-align:right;margin-top:32px">
                    <a-button ghost @click="cancelBasicInfo">取消</a-button>
                    <a-button type="primary" @click="sureDelBasicInfo" style="margin-left:16px;">确认</a-button>
                </div>
            </div>
        </a-modal>
        <div v-if="jumpSource=='view'" style="display:inline-block;width:52px;position:absolute;right:28px;bottom:48px;">
            <div @click="showChat" style="height:52px;border-radius:26px;cursor:pointer;background:rgba(42, 130, 228, 1);box-shadow:0px 3px 20px 0px rgba(42, 130, 228, 0.24);text-align:center;line-height:60px;">
                <a-icon style="font-size:24px;color:rgba(255, 255, 255, 1);" type="message" />
            </div>
            <div style="text-align:center;color:rgba(18, 18, 18, 1);font-size:13px;margin-top:8px;">对话测试</div>
        </div>
        <div v-if="ifShowChat" style="width:600px;height:560px;box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.08);position:absolute;right:0px;bottom:0px;background:rgba(255, 255, 255, 1);display:flex;flex-direction:column;border-radius:8px;overflow:hidden;padding-bottom:8px;">
            <div style="height:48px;line-height:48px;background:rgba(238, 238, 238, 1);padding:0 16px 0 24px">
                <span style="color:rgba(51, 51, 51, 1);font-size:16px;">对话</span>
                <a-icon @click="closeChat" type="close" style="float:right;margin:15px 0 0 0;font-size:16px;color:rgba(80, 80, 80, 1);cursor:pointer;" />
            </div>
            <div style="flex:1;overflow-y:auto;padding:0 12px 12px;" id="chatBody">
                <div v-for="(item,index) in chatData" :key="index">
                    <div class="chat-gpt" v-if="item.question!=''">
                        <img style="width:32px;border-radius:10px;height:32px;" src="./../assets/img/step-avator.png" alt="">
                        <div style="flex:1;margin:0 8px;border:1px solid rgba(229, 231, 235, 1);background:rgba(244, 244, 245, 0.5);border-radius:8px;color:rgba(18, 18, 18, 1);font-size:13px;padding:8px;word-break:break-all">
                            {{item.question}}
                        </div>
                        <a-icon v-if="!item.ifPlay" @click="tryListen(item.question,index,'jianli')" style="color:rgba(34, 215, 187, 1);font-size:18px;cursor:pointer;position:absolute;right:-24px;top:50%;margin-top:-10px;" type="play-circle" />
                        <a-icon v-if="item.ifPlay" style="color:rgba(34, 215, 187, 1);font-size:18px;cursor:pointer;position:absolute;right:-24px;top:50%;margin-top:-10px;" type="pause-circle" />
                    </div>
                    <span v-if="item.question==''" class="chat-loading">
                        <a-icon class="gpt-icon" type="loading" />正在输入中...
                    </span>
                    <div style="clear:both;"></div>
                    <div class="chat-user" v-if="item.answer!=''">
                        {{item.answer}}
                    </div>
                    <div style="clear:both"></div>
                </div>
                <div v-if="tryBiographicalBool" class="chat-error" style="margin-top:12px;">
                    <span @click="sendDataToBiographical" style="color:rgba(42, 130, 228, 1);cursor:pointer;margin-left:40px;text-decoration:underline">太慢啦，快些输入吧</span>
                </div>
            </div>
            <div style="height:108px;padding:0 8px;position:relative;">
                <a-textarea @keyup.enter="chatToBiographical(1)" :disabled="disabledBiographical" v-model="biographicalData" placeholder="请输入回答" style="resize: none;height:108px;border:1px solid rgba(229, 231, 235, 1);"  ref="binput" />
                <span @click="chatToBiographical(1)" style="position:absolute;right:16px;bottom:8px;cursor:pointer;width:52px;height:32px;display:inline-block;text-align:center;line-height:32px;color:#fff;font-size:14px;z-index:1000;background:rgba(34, 215, 187, 1);border-radius:6px;">发送</span>
            </div>
        </div>
        <audio id="music2" style="display:none" controls autoplay :src="voiceUrl"></audio>
        <audio id="music3" style="display:none" controls :src="voiceUrl2"></audio>
        <audio id="music4" style="display:none" controls :src="voiceUrl3"></audio>
        <a-modal :centered='true' :maskClosable='false' v-model.trim="screenModal" title="外链分享" footer='' width='720px'>
            <div class="share-modal modal-public">
                <div class="copy-link">
                    <a-input id="copyHtml1" readonly="readonly" :placeholder="linkUrl" />
                    <span @click="copyLink()">复制链接</span>
                </div>
            </div>
        </a-modal>
    </div>
</template>
  
<script>
    export default {
        name: 'Gpt',
        data() {
            return {
                projectId: '',
                currentStep: 0,
                chatList: [],
                jobDuty: {
                    content: '请用50个字描述机器人的工作职责请用50个字描述机器人的工作职责请用50个字描述机器人的工作职责请用50个字描述机器人的工作职责请用50个字描述机器人的工作职责请用50个字描',
                    ifEdit: false
                },
                bgInfoData: [
                    {
                        question: '好的，第一个问题：请问您的公司名称是什么？',
                        answer:'江苏楷文电信技术有限公司',
                        ifEdit: false
                    },
                    {
                        question: '好的，第一个问题：请问您的公司名称是什么？',
                        answer:'江苏楷文电信技术有限公司',
                        ifEdit: false
                    },
                    {
                        question: '好的，第一个问题：请问您的公司名称是什么？',
                        answer:'江苏楷文电信技术有限公司',
                        ifEdit: false
                    },
                    {
                        question: '好的，第一个问题：请问您的公司名称是什么？',
                        answer:'江苏楷文电信技术有限公司',
                        ifEdit: false
                    },
                ],
                extraInfoData: [
                    {
                        content: '好的，第一个问题：请问您的公司名称是什么？',
                        ifEdit: false
                    },
                    {
                        content: '好的，第一个问题：请问您的公司名称是什么？',
                        ifEdit: false
                    },
                    {
                        content: '好的，第一个问题：请问您的公司名称是什么？',
                        ifEdit: false
                    },
                    {
                        content: '好的，第一个问题：请问您的公司名称是什么？',
                        ifEdit: false
                    },
                ],
                deleteModal: false,
                failModal: false,
                addModal: false,
                delDataModal: false,
                basicInfoModal: false,
                readOnly: false,
                shareSwitch: false,
                chatSwitch: true,
                chatData: [],
                ifShowChat: false,
                gptName: '',
                jobTplList: [],
                tplId: '',
                step1Detail: {
                    name: '请选择职业背景',
                    des: '这个步骤非常重要，因为它决定了助手所需要掌握的知识和技能，以及与用户的交互方式。'
                },
                tplContent: '',
                disabledTpl: false,
                voiceUrl: '',
                biographicalDetail: '',
                basicInfoWordList: [],
                currentBasicWord: '',
                currentSelectWord: undefined,
                tryTplBool: false,
                jumpSource: '',
                biographicalData: '',
                disabledBiographical: false,
                tryBiographicalBool: false,
                screenModal: false,
                linkUrl: '',
                personalName: '',
                textData: [],
                voiceUrl2: '',
                voiceUrl3: '',
                currentIndex: 0,
                ifLast: false,
                currentType: ''
            }
        },
        methods: {
            editInfoContent(index) {
                this.biographicalDetail.baseInfo[index]['ifEdit'] = true
            },
            offInfoContent(index) {
                this.biographicalDetail.baseInfo[index]['ifEdit'] = false
            },
            sureInfoContent(index, type, qaId, question, answer) {
                this.biographicalDetail.baseInfo[index]['ifEdit'] = false
                this.perfectBiographical(type, qaId, question, answer)
            },
            addInfoList() {
                // let obj = {
                //     question: '信息名称',
                //     answer: '信息内容',
                //     ifEdit: true,
                //     qaId: ''
                // }
                // this.biographicalDetail.baseInfo.push(obj)
                this.basicInfoModal = true
                this.currentSelectWord = undefined
                this.queryBasicInfoWord()
            },
            delInfoList(index, id) {
                this.biographicalDetail.baseInfo.splice(index,1)
                this.deleteQaContent(id)
            },
            editJobDuty() {
                this.biographicalDetail.responsibility.ifEdit = true
            },
            offJobDuty() {
                this.biographicalDetail.responsibility.ifEdit = false
                this.queryBiographicalDel()
            },
            sureJobDuty(type, qaId, question, answer) {
                this.biographicalDetail.responsibility.ifEdit = false
                this.perfectBiographical(type, qaId, question, answer)
            },
            editBg(index) {
                this.biographicalDetail.background[index]['ifEdit'] = true
            },
            delBg(index, id) {
                this.biographicalDetail.background.splice(index,1)
                this.deleteQaContent(id)
            },
            offBg(index) {
                this.biographicalDetail.background[index]['ifEdit'] = false
                this.queryBiographicalDel()
            },
            sureBg(index, type, qaId, question, answer) {
                this.biographicalDetail.background[index]['ifEdit'] = false
                this.perfectBiographical(type, qaId, question, answer)
            },
            addBgInfo() {
                // console.log(this.biographicalDetail)
                let obj =  {
                    question: '请输入问题',
                    answer:'请输入回答',
                    qaId: '',
                    ifEdit: true
                }
                this.biographicalDetail.background.push(obj)
                this.$forceUpdate()
            },
            editExtra(index) {
                this.biographicalDetail.supplement[index]['ifEdit'] = true
            },
            delExtra(index,id) {
                this.biographicalDetail.supplement.splice(index,1)
                this.deleteQaContent(id)
            },
            offExtra(index) {
                this.biographicalDetail.supplement[index]['ifEdit'] = false
                this.queryBiographicalDel()
            },
            sureExtra(index, type, qaId, question, answer) {
                this.biographicalDetail.supplement[index]['ifEdit'] = false
                this.perfectBiographical(type, qaId, question, answer)
            },
            addExtraInfo() {
                let obj =  {
                    question: '',
                    answer: '请输入内容',
                    qaId: '',
                    ifEdit: true
                }
                this.biographicalDetail.supplement.push(obj)
            },
            lastStep() {
                if(this.currentStep != 0){
                    this.currentStep -- 
                }
            },
            nextStep() {
                if(this.currentStep == 0){
                    if(this.tplId != '') {
                        this.currentStep ++
                    }else{
                        this.$message.error('请先选择职业模板');
                    }
                }else if(this.currentStep == 1){
                    this.currentStep ++
                    this.chatToTpl()
                }else if(this.currentStep == 2){
                    this.currentStep ++
                    this.createBiographical()
                }else if(this.currentStep == 3){
                    this.currentStep ++
                }
            },
            closeWindow() {
                this.$router.push({path: '/Gpt',query:{projectId:this.projectId,
                    name:this.gptName,
                    step: 3,
                    jumpSource: 'view'}
                });
                location.reload() 
            },
            cancelDelete() {
                this.deleteModal = false
            },
            sureDelete() {
                this.deleteModal = false
            },
            cancelFail() {
                this.failModal = false
            },
            sureFail() {
                this.failModal = false
            },
            cancelDelData() {
                this.delDataModal = false
            },
            sureDelData() {
                this.delDataModal = false
                this.ifShowChat = false 
                this.chatData = []
            },
            handleChange(value) {
                this.currentBasicWord = value
            },
            cancelBasicInfo() {
                this.basicInfoModal = false
            },
            sureDelBasicInfo() {
                if(this.currentSelectWord == undefined){
                    this.$message.error('请选择新增字段')
                }else{
                    this.basicInfoModal = false
                    this.perfectBiographical(1, '', this.currentBasicWord, '')
                }
            },
            changeShare(checked) {
                this.shareSwitch = checked
                if(checked){
                    this.biographicalDetail.isShare = 1
                    this.changeShareState(1)
                }else{
                    this.biographicalDetail.isShare = 0
                    this.changeShareState(0)
                }
            },
            changeShareState(state) {
                this.axios.post('/api/assistant/shareResume', {
                    projectId: this.projectId,
                    status: state
                })
                .then(response=> {
                    if(response.data.code == 0){
                        this.queryBiographicalDel()
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            changeChat(checked) {
                this.chatSwitch = checked
                if(checked){
                    this.biographicalDetail.isOpenChat = 1
                    this.changeChatState(1)
                }else{
                    this.biographicalDetail.isOpenChat = 0
                    this.changeChatState(0)
                }
            },
            changeChatState(state) {
                this.axios.post('/api/assistant/openResumeChat', {
                    projectId: this.projectId,
                    status: state
                })
                .then(response=> {
                    if(response.data.code == 0){
                        this.queryBiographicalDel()
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            showChat() {
                this.ifShowChat = true
                this.chatData = []
                this.chatToBiographical()
            },
            closeChat() {
                this.delDataModal = true
            },
            chatToBiographical(data) {
                if(data == 1){
                    this.chatData[this.chatData.length - 1]['answer'] = this.biographicalData
                }
                this.disabledBiographical = true
                this.biographicalData = ''
                setTimeout(()=>{
                    let obj = {}
                    obj.question = ''
                    obj.answer = ''
                    obj.ifPlay = false
                    this.chatData.push(obj)
                    this.scrollTopBody()
                })
                this.sendDataToBiographical()
            },
            playVoice(data) {
                this.voiceUrl = 'http://47.111.165.100:8005/tts?text='+data+'&format=wav&speaker=47&voice=zh-CN-XiaochenNeural&speechRate=0&timestamp='+(new Date()).getTime()
            },
            playVoice2(data) {
                this.voiceUrl2 = 'http://47.111.165.100:8005/tts?text='+data+'&format=wav&speaker=47&voice=zh-CN-XiaochenNeural&speechRate=0&timestamp='+(new Date()).getTime()
            },
            playVoice3(data) {
                this.voiceUrl3 = 'http://47.111.165.100:8005/tts?text='+data+'&format=wav&speaker=47&voice=zh-CN-XiaochenNeural&speechRate=0&timestamp='+(new Date()).getTime()
            },
            replaceAll(str, find, replace) {
                return str.replace(new RegExp(find, 'g'), replace);
            },
            carryPlay() {
                let that = this
                for (let i = 0; i < this.textData.length; i++) {
                    (function (t) {
                        setTimeout(function () {
                            that.playVoice2(that.textData[i]['value'])
                        }, 500 * t);
                    })(i)
                }
                for(let i = 0; i < this.textData.length; i++){
                    if(this.textData[i]['flag'] == false){
                        this.textData[i]['flag'] = true
                        this.playVoice(this.textData[i]['value'])
                        return
                    }
                }
            },
            sendDataToBiographical() {
                this.tryBiographicalBool = false
                this.axios.post('/api/assistant/chatWithResume', {
                    projectId: this.projectId,
                    qaList: this.chatData
                })
                .then(response=> {
                    if(response.data.code == 0){
                        let that = this
                        let content = response.data.data.content
                        this.playVoice3(content)
                        let data2 = this.replaceAll(content, '。', '。@@')
                        let data3 = this.replaceAll(data2, '？', '？@@')
                        let data4 = this.replaceAll(data3, '；', '；@@')
                        let data5 = data4.split("@@")
                        this.textData = []
                        for(let i = 0; i < data5.length; i++){
                            let obj = {}
                            obj.flag = false
                            obj.value = data5[i]
                            if(data5[i]!=''){
                                this.textData.push(obj) 
                            }
                        }
                        this.carryPlay()
                        for (let i = 0; i < content.length; i++) {
                            (function (t) {   
                                setTimeout(function () {
                                    that.chatData[that.chatData.length - 1]['question'] += content[t]
                                    that.scrollTopBody()
                                }, 75 * t);	
                            })(i)   
                        }
                        this.disabledBiographical = false
                        this.$nextTick(()=>{
                            this.$refs.binput.focus()
                        })
                    }else{
                        this.tryBiographicalBool = true
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            queryJobTpl() {
                this.axios(
                    {
                        method:'get',
                        url:'/api/assistant/templateList', 
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        this.jobTplList = response.data.data
                    }else{
                        this.$message.error(response.data.message);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            chooseTpl(item) {
                if(this.tplId == item.id){
                    this.tplId = ''
                    this.step1Detail.name = '请选择职业背景'
                    this.step1Detail.des = '这个步骤非常重要，因为它决定了助手所需要掌握的知识和技能，以及与用户的交互方式。'
                }else{
                    this.tplId = item.id
                    this.step1Detail.name = item.name
                    this.step1Detail.des = item.description
                }
            },
            chatToTpl(data) {
                if(data == 1){
                    this.chatList[this.chatList.length - 1]['answer'] = this.tplContent
                }
                this.disabledTpl = true
                this.tplContent = ''
                setTimeout(()=>{
                    let obj = {}
                    obj.question = ''
                    obj.answer = ''
                    obj.ifPlay = false
                    this.chatList.push(obj)
                    this.scrollTopCon()
                })
                this.sendDataToTpl()
            },
            sendDataToTpl() {
                this.tryTplBool = false
                this.axios.post('/api/assistant/chatWithMask', {
                    id: this.tplId,
                    qaList: this.chatList
                })
                .then(response=> {
                    if(response.data.code == 0){
                        let that = this
                        let content = response.data.data.content
                        this.playVoice3(content)
                        let data2 = this.replaceAll(content, '。', '。@@')
                        let data3 = this.replaceAll(data2, '？', '？@@')
                        let data4 = this.replaceAll(data3, '；', '；@@')
                        let data5 = data4.split("@@")
                        this.textData = []
                        for(let i = 0; i < data5.length; i++){
                            let obj = {}
                            obj.flag = false
                            obj.value = data5[i]
                            if(data5[i]!=''){
                                this.textData.push(obj) 
                            }
                        }
                        this.carryPlay()

                        for (let i = 0; i < content.length; i++) {
                            (function (t) {   // 注意这里是形参
                                setTimeout(function () {
                                    that.chatList[that.chatList.length - 1]['question'] += content[t]
                                    that.scrollTopCon()
                                }, 75 * t);	// 还是每秒执行一次，不是累加的
                            })(i)   // 注意这里是实参，这里把要用的参数传进去
                        }
                        this.disabledTpl = false
                        this.$nextTick(()=>{
                            this.$refs.ainput.focus()
                        })
                    }else{
                        this.tryTplBool = true
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            scrollTopCon() {
                this.$nextTick(function() {
                    let div = document.getElementById('chatDiv');
                    div.scrollTop = div.scrollHeight;
                })
            },
            scrollTopBody() {
                this.$nextTick(function() {
                    let div = document.getElementById('chatBody');
                    div.scrollTop = div.scrollHeight;
                })
            },
            tryListen(content,index,type) {
                this.voiceUrl = 'http://47.111.165.100:8005/tts?text='+content+'&format=wav&speaker=47&voice=zh-CN-XiaochenNeural&speechRate=0&timestamp='+(new Date()).getTime()
                if(type == 'tpl'){
                    for(let i = 0; i < this.chatList.length; i++){
                        if(i == index){
                            this.chatList[index]['ifPlay'] = true
                        }else{
                            this.chatList[i]['ifPlay'] = false 
                        }
                    }
                }else{
                    for(let i = 0; i < this.chatData.length; i++){
                        if(i == index){
                            this.chatData[index]['ifPlay'] = true
                        }else{
                            this.chatData[i]['ifPlay'] = false 
                        }
                    }
                }
                this.currentIndex = index
                this.currentType = type
            },
            createBiographical() {
                this.axios.post('/api/assistant/generateAssistant', {
                    name: this.gptName,
                    templateId: this.tplId,
                    qaList: this.chatList
                })
                .then(response=> {
                    if(response.data.code == 0){
                        this.projectId = response.data.data.projectId
                        this.queryBiographicalDel()
                    }else{
                        this.$message.error(response.data.message);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            queryBiographicalDel() {
                this.axios(
                    {
                        method:'get',
                        url:'/api/assistant/resume', 
                        params: {
                            projectId: this.projectId,
                        }
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        this.biographicalDetail = response.data.data
                        if(response.data.data.isShare == 1){
                            this.shareSwitch = true
                        }else{
                            this.shareSwitch = false
                        }
                        if(response.data.data.isOpenChat == 1){
                            this.chatSwitch = true
                        }else{
                            this.chatSwitch = false
                        }
                    }else{
                        this.$message.error(response.data.message);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            queryBasicInfoWord() {
                this.axios(
                    {
                        method:'get',
                        url:'/api/assistant/basicFieldList', 
                        params: {
                            projectId: this.projectId,
                        }
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        this.basicInfoWordList = response.data.data
                    }else{
                        this.$message.error(response.data.message);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            perfectBiographical(type, qaId, question, answer) {
                this.axios.post('/api/assistant/updateAssistant', {
                    projectId: this.projectId,
                    type: type,
                    qaId: qaId,
                    question: question,
                    answer: answer
                })
                .then(response=> {
                    if(response.data.code == 0){
                        this.queryBiographicalDel()
                    }else{
                        this.$message.error(response.data.message);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            deleteQaContent(id) {
                this.axios.post('/api/assistant/deleteResumeQa', {
                    projectId: this.projectId,
                    qaId: id,
                })
                .then(response=> {
                    if(response.data.code == 0){
                        this.queryBiographicalDel()
                    }else{
                        this.$message.error(response.data.message);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            shareModal() {
                let url = ''
                let protocol = window.location.protocol;
                let host = window.location.host;
                url = protocol + '//' + host + '/#/LiographicalLink?projectId=' + this.projectId+'&apply='+this.personalName+'邀请您在线体验Chatgpt助手场景《['+this.gptName+']》，点击链接开始模拟对话'
                this.linkUrl = url
                this.screenModal = true
            },
            copyLink() {
                let url = ''
                let protocol = window.location.protocol;
                let host = window.location.host;
                url = protocol + '//' + host + '/#/LiographicalLink?projectId=' + this.projectId+'&apply='+this.personalName+'邀请您在线体验Chatgpt助手场景《'+this.gptName+'》，点击链接开始模拟对话'
                let text = url
                let input = document.getElementById("copyHtml1");
                input.value = text; 
                input.select(); 
                document.execCommand("copy"); 
                this.$message.success('复制成功');
                this.screenModal = false
            }
        },
        mounted: function() {
            this.gptName = this.$route.query.name
            this.projectId = this.$route.query.projectId
            this.jumpSource = this.$route.query.jumpSource
            if(this.$route.query.step == 3){
                this.currentStep = 3
                this.queryBiographicalDel()
            }
            this.queryJobTpl()
            this.personalName = sessionStorage.getItem('userName')
            let that = this
            let Music2 = document.getElementById("music2")
            Music2.addEventListener('ended',function () {
                that.carryPlay()
                if(that.currentType == 'tpl'){
                    that.chatList[that.currentIndex]['ifPlay'] = false
                }else{
                    that.chatData[that.currentIndex]['ifPlay'] = false
                }
            }, false)
        }
    }
</script>
  
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
    ::-webkit-scrollbar {/*滚动条整体部分，其中的属性有width,height,background,border（就和一个块级元素一样）等。*/  
        width: 2px !important;  
        height: 0px !important;  
    }  
    .step-progress{
        height: 32px;
        line-height: 32px;
        width: 1200px;
        margin: 0 auto;
        margin-bottom: 20px;
        .step-num{
            height: 30px;
            width: 30px;
            display: inline-block;
            color: rgba(158, 172, 196, 1);
            border-radius: 15px;
            border: 1px solid rgba(158, 172, 196, 0.8);
            text-align: center;
            line-height: 30px;
            font-size: 13px;
            float: left;
        }
        .step-num-active{
            color: #fff;
            background: rgba(34, 215, 187, 1);
            border: 1px solid rgba(34, 215, 187, 1);
        }
        .step-text{
            margin-left: 9px;
            color: rgba(56, 56, 56, 1);
            font-size: 15px;
            float: left;
        }
        .step-text-active{
            color: rgba(34, 215, 187, 1);
        }
        .step-line{
            display: inline-block;
            height: 2px;
            width: 184px;
            background: rgba(229, 231, 235, 1);
            float: left;
            margin: 14px 18px 0;
        }
        .step-line-active{
            background: rgba(34, 215, 187, 1);
        }
    }
    .last-step{
        display: inline-block;
        width: 60px;
        position: absolute;
        left: 24px;
        top: 50%;
        margin-top: -60px;
        span{
            display: inline-block;
            width: 60px;
            height: 60px;
            text-align: center;
            line-height: 60px;
            color: rgba(34, 215, 187, 1);
            font-size: 24px;
            background: rgba(255, 255, 255, 1);
            cursor: pointer;
            border-radius: 30px;
            box-shadow: 0px 2px 24px 0px rgba(158, 172, 196, 0.24);;
        }
        span:hover{
            background: rgba(34, 215, 187, 1);
            box-shadow: 0px 2px 24px 0px rgba(158, 172, 196, 0.24);
            color: #fff;
        }
        div{
            color: rgba(80, 80, 80, 1);
            font-size: 14px;
            text-align: center;
            margin-top: 12px;
        }
    }
    .next-step{
        display: inline-block;
        width: 60px;
        position: absolute;
        right: 24px;
        top: 50%;
        margin-top: -60px;
        span{
            display: inline-block;
            width: 60px;
            height: 60px;
            text-align: center;
            line-height: 60px;
            color: rgba(34, 215, 187, 1);
            font-size: 24px;
            background: rgba(255, 255, 255, 1);
            cursor: pointer;
            border-radius: 30px;
            box-shadow: 0px 2px 24px 0px rgba(158, 172, 196, 0.24);;
        }
        span:hover{
            background: rgba(34, 215, 187, 1);
            box-shadow: 0px 2px 24px 0px rgba(158, 172, 196, 0.24);
            color: #fff;
        }
        div{
            color: rgba(80, 80, 80, 1);
            font-size: 14px;
            text-align: center;
            margin-top: 12px;
        }
    }
    .chart-box{
        .chart-item{
            display: inline-block;
            width: 244px;
            height: 120px;
            padding: 20px;
            border: 1px solid rgba(229, 231, 235, 1);
            border-radius: 16px;
            margin: 20px 0 0 20px;
            cursor: pointer;
            .chart-body{
                display: flex;
                height: 100%;
                .left-chart{
                    width: 60px;
                    margin-right: 16px;
                    .img-box{
                        border-radius: 11px;
                        border: 1px solid rgba(229, 231, 235, 1);
                        text-align: center;
                        // display: inline-block;
                        height: 60px;

                    }
                    .img-avatar{
                        width: 40px;
                        height: 40px;
                        border-radius: 20px;
                        margin-top: 10px;
                    }
                }
                .right-chart{
                    display: inline-block;
                    flex: 1;
                    .chart-name{
                        color: rgba(18, 18, 18, 1);
                        font-size: 20px;
                        font-weight: bold;
                    }
                    .chart-content{
                        color: rgba(179, 184, 193, 1);
                        font-size: 13px;
                        margin-top: 4px;
                    }
                }
            }
        } 
        .chart-item:hover{
            border: 1px solid rgba(34, 215, 187, 1);
        }
        .chart-item-active{
            border: 2px solid rgba(34, 215, 187, 1);
            background: rgba(34, 215, 187, 0.08);
            .left-chart{
                .img-box{
                    border: 2px solid rgba(35, 197, 159, 1) !important;
                }
            }
        }
        .chart-item-active:hover{
            border: 2px solid rgba(34, 215, 187, 1) !important;
        }
    }
    .gpt-role{
        display: inline-block;
        width: 70%;
        float: left;
        margin-top: 24px;
        display: flex;
        .gpt-head{
            display: inline-block;
            width: 32px;
            height: 32px;
            border-radius: 10px;
            border: 1px solid rgba(229, 231, 235, 1);
            text-align: center;
            line-height: 30px;
            color: rgba(134, 157, 252, 1);
            font-size: 12px;
            float: left;
        }
        .gpt-content{
            padding: 12px;
            background: rgba(244, 244, 245, 0.5);
            border: 1px solid rgba(229, 231, 235, 1);
            color: rgba(18, 18, 18, 1);
            font-size: 14px;
            border-radius: 8px;
            margin: 0 8px;
            float: left;
            flex: 1;
            word-break: break-all;
        }
        .gpt-img{
            width: 20px;
            cursor: pointer;
            float: left;
            margin-top: 12px;
            color: rgba(34, 215, 187, 1);
            font-size: 18px;
        }
        .gpt-loading{
            line-height: 32px;
            color: rgba(158, 172, 196, 1);
            i{
                margin: 0 8px;
            }
        }
    }
    .user-role{
        display: inline-block;
        width: 70%;
        float: right;
        margin-top: 24px;
        .user-content{
            display: inline-block;
            background: rgba(34, 215, 187, 0.08);
            border: 1px solid rgba(229, 231, 235, 1);
            font-size: 14px;
            color: rgba(18, 18, 18, 1);
            padding: 12px;
            border-radius: 8px;
            float: right;
        }
    }
    .clean{
        clear: both;
    }
    .basic-info{
        .info-list{
            height: 35px;
            line-height: 35px;
            display: flex;
        }
        .info-title{
            display: inline-block;
            width: 70px;
            margin-right: 22px;
            text-align: left;
            color: rgba(158, 172, 196, 1);
            font-size: 13px;
        }
        .info-content{
            display: inline-block;
            // flex: 1;
            color: rgba(0, 0, 0, 1);
            font-size: 13px;
            margin-right: 12px;
            text-align: left;
            overflow: hidden;
        }
        .info-input{
            display: inline-block;
            flex: 1;
            color: rgba(0, 0, 0, 1);
            font-size: 13px;
            margin-right: 12px;
            text-align: left;
            overflow: hidden; 
        }
        .info-edit{
            color: rgba(34, 215, 187, 1);
            cursor: pointer;
            font-size: 14px;
            margin-left: 12px;
            margin-top: 10px;
            display: none;
        }
        .info-del{
            color: rgba(239, 67, 67, 1);
            cursor: pointer;
            font-size: 14px;
            margin-left: 16px;
            margin-top: 10px;
            display: none;
        }
        .info-off{
            color: rgba(158, 172, 196, 0.8);
            font-size: 13px;
            cursor: pointer;
            margin-right: 12px;
        }
        .info-sure{
            color: rgba(34, 215, 187, 1);
            font-size: 13px;
            cursor: pointer;
        }
        .info-list:hover{
            .info-edit{
                display: inline-block;
            }
            .info-del{
                display: inline-block;
            }
        }
    }
    .job-duty{
        .job-content{
            .job-edit{
                display: none;
                color: rgba(34, 215, 187, 1);
                font-size: 14px;
            }
        }
        .job-content:hover{
            .job-edit{
                display: inline-block;
            }
        }
    }
    .bg-info{
        .bg-list{
            .edit-bg{
                color:rgba(34, 215, 187, 1);
                font-size:14px;
                margin-right:16px;
                cursor:pointer;
                display: none;
            }
            .del-bg{
                color:rgba(239, 67, 67, 1);
                font-size:14px;
                cursor:pointer;
                display: none;
            }
            .off-bg{
                cursor: pointer;
                color: rgba(158, 172, 196, 0.8);
                font-size: 13px;
                margin-right: 12px;
            }
            .save-bg{
                cursor: pointer;
                color: rgba(34, 215, 187, 1);
                font-size: 13px;
            }
        }
        .bg-list:hover{
            .edit-bg{
                display: inline-block;
            }
            .del-bg{
                display: inline-block;
            }
        }
    }
    .extra-require{
        .extra-list{
            .edit-extra{
                color:rgba(34, 215, 187, 1);
                font-size:14px;
                margin-right:16px;
                cursor:pointer;
                display: none;
            }
            .del-extra{
                color:rgba(239, 67, 67, 1);
                font-size:14px;
                cursor:pointer;
                display: none;
            }
            .off-extra{
                cursor: pointer;
                color: rgba(158, 172, 196, 0.8);
                font-size: 13px;
                margin-right: 12px;
            }
            .save-extra{
                cursor: pointer;
                color: rgba(34, 215, 187, 1);
                font-size: 13px;
            }
        }
        .extra-list:hover{
            .edit-extra{
                display: inline-block;
            }
            .del-extra{
                display: inline-block;
            }
        }
    }
    .chat-gpt{
        float: left;
        max-width: 70%;
        margin-top: 12px;
        display: flex;
        position: relative;
    }
    .chat-loading{
        line-height: 32px;
        float: left;
        color: rgba(158, 172, 196, 1);
        i{
            margin: 0 8px;
        }
    }
    .chat-user{
        display: inline-block;
        padding: 8px;
        float: right;
        background: rgba(34, 215, 187, 0.08);
        border: 1px solid rgba(229, 231, 235, 1);
        border-radius: 8px;
        color: rgba(18, 18, 18, 1);
        font-size: 13px;
        margin-top: 12px;
    }
    .copy-link{
        height: 62px;
        input{
            width: 464px;
            float: left;
            height: 40px;
        }
        span{
            float: left;
            display: inline-block;
            width: 88px;
            height: 40px;
            border: 1px solid rgba(121, 136, 155, 0.3);
            cursor: pointer;
            border-radius: 0px 4px 4px 0px;
            line-height: 40px;
            text-align: center;
        }
    }
</style>
  